import axios from 'axios';
import { APIBASE } from './../environment';

export * from './other';
export * from './permissions';
export * from './url-builder';
export * from './user';

export const http = axios.create({
 baseURL: APIBASE,
});

http.interceptors.request.use((config) => {
 config.headers.Authorization = 'Bearer ' + localStorage.token;
 return config;
});
